import React from 'react';
import type { Experiment } from '../../types/vuser';
import { resolveExperimentDisplayState } from '../../utils/experimentDisplay';
import FailedJobErrorMessage from '../ui/FailedJobErrorMessage';
import './ExperimentStatusBadge.css';

export interface ExperimentStatusBadgeProps {
  experiment: Pick<Experiment, 'status' | 'dataset_status' | 'error_message'>;
  showWarningMessage?: boolean;
  className?: string;
}

const ExperimentStatusBadge: React.FC<ExperimentStatusBadgeProps> = ({
  experiment,
  showWarningMessage = false,
  className = '',
}) => {
  const display = resolveExperimentDisplayState(experiment as Experiment);

  return (
    <div className={className}>
      <span
        className={`experiment-status-badge experiment-status-badge--${display.statusKind}`}
      >
        {display.statusKind === 'running' ? (
          <i className="fas fa-circle experiment-status-badge__pulse" aria-hidden />
        ) : null}
        {display.statusKind === 'completed' ? (
          <i className="fas fa-check-circle" style={{ fontSize: 10 }} aria-hidden />
        ) : null}
        {display.statusKind === 'completed_warnings' ? (
          <i className="fas fa-exclamation-triangle" style={{ fontSize: 10 }} aria-hidden />
        ) : null}
        {display.statusKind === 'failed' ? (
          <i className="fas fa-times-circle" style={{ fontSize: 10 }} aria-hidden />
        ) : null}
        {display.statusLabel}
      </span>
      {showWarningMessage && display.showDatasetFailureMessage && display.datasetFailureMessage ? (
        display.statusKind === 'failed' || display.statusKind === 'cancelled' ? (
          <div style={{ marginTop: 8, maxWidth: 320 }}>
            <FailedJobErrorMessage
              friendlyMessage={display.datasetFailureMessage}
              fallbackMessage="Experiment failed"
              compact
            />
          </div>
        ) : (
          <div className="experiment-dataset-warning" role="status">
            <i className="fas fa-exclamation-triangle" aria-hidden />
            <span>{display.datasetFailureMessage}</span>
          </div>
        )
      ) : null}
    </div>
  );
};

export default ExperimentStatusBadge;
